import React from 'react';
import { useAppSelector } from '../../hooks/useRedux';
import { selectCurrentUser } from '../../store/auth/authSelectors';
import { UserRole } from '../../types';

interface RoleAccessGateProps {
  allowedRoles: readonly UserRole[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const RoleAccessGate: React.FC<RoleAccessGateProps> = ({
  allowedRoles,
  children,
  fallback = null,
}) => {
  const currentUser = useAppSelector(selectCurrentUser);
  const currentUserRole = currentUser?.role ?? null;

  if (!currentUserRole || !allowedRoles.includes(currentUserRole)) {
    return fallback as React.ReactElement | null;
  }

  return children as React.ReactElement | null;
};
